var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('locationnetworks',{attrs:{"locationnetworks":_vm.locationNetworks,"isloading":_vm.isLoading},on:{"locationNetworkSaved":function($event){return _vm.fetchLocationNetworks()}}}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }